import { PayloadAction } from '@reduxjs/toolkit'
import { AppState } from '../slices/appSlice'

export const setFullScreen = (state: AppState, action: PayloadAction<boolean>) => {
  state.isFullScreen = action.payload
}

export const setChartClosed = (state: AppState, action: PayloadAction<boolean>) => {
  state.isChartOpen = action.payload
}

export const setDarkMode = (state: AppState, action: PayloadAction<boolean>) => {
  state.isDarkMode = action.payload
}

export const setUtc = (state: AppState, action: PayloadAction<boolean>) => {
  state.isUtc = action.payload
}
